import { Day, format, startOfWeek } from "date-fns";
import { dateParseISO } from "./dateParseISO";

/**
 * Returns the first day of the week (as yyyy-MM-dd) at or before the given
 * date. Historically weeks always started on Monday, hence the name; pass the
 * organization/user `weekStartsOn` (0=Sunday..6=Saturday) to respect the
 * configurable week start.
 */
export const getFirstMondayBefore = (date: string, weekStartsOn: Day = 1) => {
  const parsedDate = dateParseISO(date);
  const firstMondayBefore = startOfWeek(parsedDate, { weekStartsOn });
  return format(firstMondayBefore, "yyyy-MM-dd");
};
